import { defineMessages } from 'react-intl';

export default defineMessages({
    menu: {
        id: 'components.layout.menu',
        defaultMessage: 'Menu',
    },
});
